export const SUCCESS = 'success'
export const FAILURE = 'failure'
export const NOT_ELIGIBLE = 'not_eligible'
export const ASSIGNMENT_ARCHIVED = 'assignment_archived'
export const OPENED = 'opened'
export const DELIVERED = 'delivered'
